import { render, staticRenderFns } from "./Pois.vue?vue&type=template&id=674c39f0&scoped=true"
import script from "./Pois.vue?vue&type=script&lang=js"
export * from "./Pois.vue?vue&type=script&lang=js"
import style0 from "./Pois.vue?vue&type=style&index=0&id=674c39f0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674c39f0",
  null
  
)

export default component.exports